/** A lesson counts as watched at this fraction, for BOTH playback backends. */
export const COMPLETION_FRACTION = 0.9;

/**
 * Whether this moment should mark the lesson complete.
 *
 * `ended` is the honest signal, but a learner who scrubs past the outro never
 * emits it — hence the 90 % rule, which until now only the native `<video>`
 * had. Routing both backends through the adapter gives embeds the same rule.
 */
export function decideCompletion({
  ended,
  currentTime,
  duration,
  alreadyFired,
  alreadyDone,
}: {
  ended: boolean;
  currentTime: number;
  duration: number | null;
  alreadyFired: boolean;
  alreadyDone: boolean;
}): boolean {
  if (alreadyFired || alreadyDone) return false;
  if (ended) return true;
  if (duration == null || !Number.isFinite(duration) || duration <= 0) return false;
  return currentTime / duration >= COMPLETION_FRACTION;
}
